import { CorpCompanyMapper } from "@/adapters/CorpCompany.mapper";
import { assertCompanyPresent, withCorpGuard } from "@/services/corp/corpGuard";
import { toB2BError, toDataShapeError } from "@/utils/b2bErrors";
import { lazyService } from "@/utils/lazyMock";
import { supabase } from "@/utils/supabase";
export class CorpCompanyService {
    async getSummary(companyId) {
        return withCorpGuard((async () => {
            const { data, error } = await supabase().from("corp_my_companies").select("*").eq("company_id", companyId);
            if (error)
                throw toB2BError(error);
            const rows = data ?? [];
            assertCompanyPresent(rows);
            try {
                return CorpCompanyMapper.summaryToDomain(rows[0]);
            }
            catch (parseError) {
                throw toDataShapeError(parseError);
            }
        })());
    }
    async getTariff(companyId) {
        return withCorpGuard((async () => {
            const { data, error } = await supabase().from("corp_my_tariff").select("*").eq("company_id", companyId);
            if (error)
                throw toB2BError(error);
            const rows = data ?? [];
            if (rows.length === 0)
                return null;
            try {
                return CorpCompanyMapper.tariffToDomain(rows[0]);
            }
            catch (parseError) {
                throw toDataShapeError(parseError);
            }
        })());
    }
}
// Литерал REACT_APP_B2B_MOCK — см. CompanyLinkService.ts / utils/lazyMock.ts (G4).
export const corpCompanyService = process.env.REACT_APP_B2B_MOCK === "true"
    ? lazyService(() => import("@/services/corp/CorpCompanyServiceMock").then((module) => module.corpCompanyServiceMock))
    : new CorpCompanyService();
